export default function areOptionsEqual(a = {}, b = {}) {
    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    return Array.from(keys).every((key) => String(a[key] ?? '') === String(b[key] ?? ''));
}
